define(
    'BTM.GiftCertificatePatch.GiftCertificatePatch'
    , [
        'require'
    ]
    , function (
        require
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                try {
                    var PLPGroupView = require("SuiteCommerce.GiftCertificate.PLP.Group.View");
                    if (PLPGroupView) {
                        PLPGroupView.PLPGroupView.prototype.getPLPDisplayFormat = function (PLP) {
                            var display = PLP.getDisplay();
                            return display ? display.id : 'grid';
                        };
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        };
    });
